<script setup>
import { useI18n } from 'vue-i18n';
import Button from 'dashboard/components-next/button/Button.vue';

const { t } = useI18n();

const emit = defineEmits(['create']);
</script>

<template>
  <div class="flex flex-col items-center justify-center py-16 text-center">
    <div class="w-16 h-16 rounded-full bg-n-alpha-2 flex items-center justify-center mb-4">
      <span class="i-lucide-target size-8 text-n-slate-10" />
    </div>
    <h3 class="text-lg font-semibold text-n-slate-12 mb-2">
      {{ t('STRATEGIES.EMPTY_STATE.TITLE') }}
    </h3>
    <p class="text-sm text-n-slate-11 max-w-md mb-6">
      {{ t('STRATEGIES.EMPTY_STATE.DESCRIPTION') }}
    </p>
    <Button
      icon="i-lucide-plus"
      color-scheme="primary"
      @click="emit('create')"
    >
      {{ t('STRATEGIES.NEW_STRATEGY') }}
    </Button>
  </div>
</template>
